import * as React from 'react';

import SaleReportConversationPanel from "./SaleReportConversationPanel.js";

import "./SaleReportConversationDialog.scss";

export default function SaleReportConversationDialog({ setId, id, onChange }) {
	// Sale Report Conversation
	const [saleReport, setSaleReport] = React.useState(id);

	React.useEffect(() => {
		setSaleReport(id);
	}, [id, setId]);
	React.useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		saleReport
			? searchParams.set('sale-report', saleReport)
			: searchParams.delete('sale-report');
		const url = window.location.protocol + "//"
			+ window.location.host + window.location.pathname
			+ '?' + searchParams.toString();
		window.history.pushState({ path: url }, '', url);
	}, [saleReport]);

	const showSaleReportConversationModal = saleReportId => {
		setId ? setId(saleReportId) : setSaleReport(saleReportId);
	};
	window.showSaleReportConversationModal = showSaleReportConversationModal;

	const searchParams = new URLSearchParams(window.location.search);
	React.useEffect(() => {
		const saleReport = searchParams?.get('sale-report');
		saleReport && showSaleReportConversationModal(saleReport);
	}, []);

	const setter = setId || setSaleReport;
	return saleReport && (
		<div id="sale-report-conversation-dialog">
			<SaleReportConversationPanel saleReportId={saleReport} onChange={onChange} />
			<button className="close" onClick={() => setter(false)}>&times;</button>
		</div>
	);
}